import renderHTML from 'react-render-html';

const ArticleContent = (props) => {
  const { content } = props;
  return renderHTML(content);
};

export default ArticleContent;
